import { ReviewSourceTypes } from '@containers/ProductDetailContainer/model';

export const REVIEWS_MAIL_QUERY_PARAM = 'mail';
export const REVIEW_LOGIN_QUERY_PARAM = 'reviewLogin';

export const shouldOpenReviewModal = (
  search: string
): ReviewSourceTypes | null => {
  if (!search) {
    return null;
  }
  const searchParams = new URLSearchParams(search);
  return searchParams.get(REVIEWS_MAIL_QUERY_PARAM) === '1'
    ? ReviewSourceTypes.EMAIL
    : searchParams.get(REVIEW_LOGIN_QUERY_PARAM) === 'true'
    ? ReviewSourceTypes.DIRECT
    : null;
};
